/**
 * Tipos e rótulos do cadastro de instalação elétrica em etapas (issue #364, D10).
 */
import type {
  ElectricalInstallationStatus,
  ElectricalInstallationType,
  ElectricalVoltageClass,
} from '../../../../types/electricalInstallation';

export type ElectricalWizardStepKey = 'identification' | 'records' | 'documents';

export const ELECTRICAL_WIZARD_STEPS: ReadonlyArray<{ key: ElectricalWizardStepKey; label: string }> = [
  { key: 'identification', label: 'Identificação' },
  { key: 'records', label: 'Inspeções e manutenções' },
  { key: 'documents', label: 'Documentos técnicos' },
];

/**
 * Desfecho de guardar o formulário aberto: `incompleto` falta preencher algo (a etapa marca os campos);
 * `recusado` o servidor não aceitou e a etapa já mostra a frase dele.
 */
export type ResultadoDoEnvio = 'enviado' | 'incompleto' | 'recusado';

/** O que uma etapa de lista (inspeções, documentos) oferece a quem a controla. */
export interface StepHandle {
  /** Guarda o formulário aberto, se tiver algo digitado. */
  salvarPendente: () => Promise<ResultadoDoEnvio>;
}

export interface ListStepProps {
  installationId: string;
  /** Quem pode alterar (`electrical_installation.update`); sem isso a etapa só mostra e baixa. */
  canEdit: boolean;
  onDirtyChange: (dirty: boolean) => void;
  onSaved: (message: string) => void;
}

export interface IdentificationValues {
  /** Empresa dona da instalação; só é perguntada na criação, quando não há empresa ativa. */
  companyId: string;
  name: string;
  tag: string;
  installationType: ElectricalInstallationType;
  typeDescription: string;
  nominalVoltage: string;
  /** Vinda do servidor; `null` enquanto a instalação não foi salva (D8: a regra não se repete na tela). */
  voltageClass: ElectricalVoltageClass | null;
  location: string;
  departmentId: string;
  status: ElectricalInstallationStatus;
  observations: string;
}

export type IdentificationErrors = Partial<Record<keyof IdentificationValues, string>>;

export const EMPTY_IDENTIFICATION: IdentificationValues = {
  companyId: '',
  name: '',
  tag: '',
  installationType: 'QUADRO_DE_DISTRIBUICAO',
  typeDescription: '',
  nominalVoltage: '',
  voltageClass: null,
  location: '',
  departmentId: '',
  status: 'EM_OPERACAO',
  observations: '',
};
